'use client';

import { VStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../../../components/typography';
import { formatCategoryForDisplay } from '../../../../../utils/category-utils';

type FlatSignalSummaryProps = {
  label: string;
  description?: string;
  category?: string;
};

export function FlatSignalSummary({
  label,
  description,
  category,
}: FlatSignalSummaryProps) {
  const displayCategory =
    category && category !== 'Unknown'
      ? formatCategoryForDisplay(category)
      : undefined;

  return (
    <VStack alignItems="stretch" gap={1} width="100%">
      <MetaDefault color="fg.muted">{label}</MetaDefault>
      {description && description !== label ? (
        <MetaDefault color="fg.muted">{description}</MetaDefault>
      ) : null}
      {displayCategory ? (
        <MetaDefault
          color={{ _light: 'neutral.light.9', _dark: 'neutral.dark.8' }}
        >
          {displayCategory}
        </MetaDefault>
      ) : null}
    </VStack>
  );
}
